export const validateName = (inputString, displayLabel) => {
  if (!inputString || inputString.trim() === '') {
    return `You must name your ${displayLabel} in order to save it.`
  } else {
    if (inputString.length > 48) {
      return `The name of your ${displayLabel} is too long. Please adjust it to contain less than 48 characters.`
    }

    const pattern = /^[\w\s-.()'"!:,&*[\]]+$/g
    if (!pattern.test(inputString)) {
      return `<p>Your ${displayLabel} name contains invalid characters. Please only use characters from the list below:</p>
             <ul>
                <li><strong>Uppercase letters: </strong>A-Z</li>
                <li><strong>Lowercase letters: </strong>a-z</li>
                <li><strong>Numbers: </strong> 0-9</li>
                <li><strong>Special characters: </strong>- . _ ( ) ' " ! : , & * [ ] </li>
             </ul>`
    }
  }
  return null
}
